import { Services } from '@sigma-frontend-libs/commons'
import { BILLING_CURRENCY } from '@sigma-legacy-libs/essentials/lib/constants'

import { currency, currentTab, permissionPresets, proxy } from '@/utils'

import { serviceNameViaPoint } from '@/components/services/url-shortener-settings/domains/utils'

import render from './render'

export default {
  name: 'UsersForm',

  mixins: [
    proxy({ type: 'object' }),
    currentTab('general'),
    currency
  ],

  props: {
    errors: {
      type: Object,
      default: () => {
        return {}
      }
    },

    isNew: Boolean,

    saveSuccessKey: {
      type: Number,
      default: 0
    }
  },

  computed: {
    canGetSettingsUser() {
      return this.checkPermissions(`advanced.${Services.settingsUser}.get`, permissionPresets.resellerUp)
    },
    canSetTariffs() {
      return this.checkPermissions(`advanced.${Services.users}.setTariffs`, permissionPresets.resellerUp)
    },
    canGetTariffs() {
      return this.checkPermissions([ `advanced.${Services.tariffs}.get`, `advanced.${Services.tariffs}.find` ], permissionPresets.resellerUp)
    },
    canSetRoutingGroups() {
      return this.checkPermissions(`advanced.${Services.users}.setRoutingGroups`, permissionPresets.resellerUp)
    },
    canGetRoutingGroups() {
      return this.checkPermissions(`advanced.${Services.routingGroups}.get`, permissionPresets.meUp)
    },
    canUpdateUsers() {
      return this.checkPermissions(`advanced.${Services.users}.update`, permissionPresets.resellerUp)
    },
    canGetTokens() {
      return this.checkPermissions(`advanced.${Services.tokens}.get`, permissionPresets.meUp)
    },
    canSetPermissions() {
      return this.checkPermissions(`advanced.${Services.users}.setPermissions`, permissionPresets.resellerUp)
    },
    canSetOtpChannels() {
      return this.checkPermissions(`advanced.${Services.users}.setOtpChannels`, permissionPresets.resellerUp)
    },
    canCreateDomains() {
      return this.checkPermissions(`advanced.${serviceNameViaPoint}.create`, permissionPresets.true)
    },
    canGetRequisites() {
      return this.checkPermissions(`advanced.${Services.requisites}.get`, permissionPresets.meUp)
    },
    canGetRecurrentPayments() {
      return this.checkPermissions(`advanced.${Services.recurrentPayments}.get`, permissionPresets.meUp)
    },

    tabs() {
      const result = [ 'general' ]

      if (!this.isNew && this.canGetSettingsUser) {
        result.push(Services.settingsUser)
      }

      if (this.canSetTariffs && this.canGetTariffs) {
        result.push(Services.tariffs)
      }

      if (this.canSetRoutingGroups && this.canGetRoutingGroups) {
        result.push(Services.routingGroups)
      }

      if (!this.isNew && this.canUpdateUsers) {
        result.push('processMessages')
      }

      if (!this.isNew && this.canGetTokens) {
        result.push(Services.tokens)
      }

      if (!this.isNew && this.canSetPermissions) {
        result.push(Services.permissions)
      }

      if (!this.isNew && this.canSetOtpChannels) {
        result.push('userChannels')
      }
      if (!this.isNew && this.canCreateDomains) {
        result.push('domainsUsers')
      }

      if (!this.isNew && this.currency === BILLING_CURRENCY.RUB) {
        if (this.canGetRequisites) {
          result.push(Services.requisites)
        }
        if (this.canGetRecurrentPayments) {
          result.push(Services.recurrentPayments)
        }
        result.push('referral')
      }

      return result
    }
  },

  mounted() {
    if (this.isNew) {
      this.currentTab = 'general'
    }

    this.getCurrency(this.proxy?.id)
  },

  render
}
